import React from "react";
import { Link } from "react-router-dom";
import { useMicrositeContext } from "./MicrositeLayout";
import { Card, CardContent } from "../../components/ui/card";
import { Calendar, ShieldCheck, Clock, Heart, ArrowRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function MicrositeHome() {
  const { clinic, slug, basePath } = useMicrositeContext();
  const primary = clinic.primary_color || "#2563EB";
  return (
    <div className="space-y-12" data-testid="microsite-home">
      {/* Hero */}
      <section className="relative overflow-hidden rounded-3xl bg-white border border-slate-200">
        {clinic.banner_file_id ? (
          <div className="absolute inset-0 opacity-30">
            <img src={`${BACKEND_URL}/api/public/files/${clinic.banner_file_id}`} alt="" className="w-full h-full object-cover" />
          </div>
        ) : (
          <div className="absolute inset-0 opacity-10" style={{ background: `linear-gradient(135deg, ${primary}, transparent)` }} />
        )}
        <div className="relative p-8 sm:p-12 lg:p-16">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold mb-3" style={{ color: primary }}>
            {clinic.name}
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-3 max-w-2xl" style={{ fontFamily: "Manrope" }}>
            {clinic.tagline || "Quality care, close to home."}
          </h1>
          <p className="text-slate-600 text-base sm:text-lg max-w-xl">
            Book an appointment online with our doctors in just a few clicks.
            No phone calls, no waiting on hold.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to={`${basePath}/book`}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-lg text-white font-semibold shadow-sm hover:shadow transition-shadow"
              style={{ backgroundColor: primary }}
              data-testid="hero-book-btn"
            >
              <Calendar className="w-4 h-4" /> Book an appointment <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to={`${basePath}/doctors`}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-white border border-slate-200 text-slate-700 font-medium hover:border-slate-300"
            >
              Meet our doctors
            </Link>
          </div>
        </div>
      </section>

      {/* Feature triplet */}
      <section className="grid sm:grid-cols-3 gap-4">
        {[
          { icon: Clock, title: "Quick bookings", desc: "Pick a time slot in seconds — no calls needed." },
          { icon: ShieldCheck, title: "Confirmed instantly", desc: "Get an SMS confirmation as soon as you book." },
          { icon: Heart, title: "Care you trust", desc: "Experienced doctors with a focus on patient outcomes." },
        ].map((f) => (
          <Card key={f.title} className="border-slate-200">
            <CardContent className="p-6">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{ backgroundColor: `${primary}1A`, color: primary }}>
                <f.icon className="w-5 h-5" />
              </div>
              <div className="font-semibold text-slate-900 mb-1" style={{ fontFamily: "Manrope" }}>{f.title}</div>
              <div className="text-sm text-slate-500">{f.desc}</div>
            </CardContent>
          </Card>
        ))}
      </section>
    </div>
  );
}
